import React, { ReactNode } from 'react';
import s from './PlayFreeImageCarousel.module.css';
import Link from 'next/link';

interface IPlayFreeImageCarousel { 
  content?: ReactNode
  backgroundImageUrl?: string
  darkenBackground?: boolean
  desktopView?: boolean
  footerStyle?: React.CSSProperties

}

const PlayFreeImageCarousel = ({
  content,
  backgroundImageUrl,
  darkenBackground = false,
  desktopView,
  footerStyle,
}: IPlayFreeImageCarousel) => {
  if (desktopView) {
    return (
      <div className={s.desktopContainer}>
        <div
          style={{
            position: 'relative',
            background: `url(${backgroundImageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%',
            height: '100vh',
          }}
        >
          <div
            className={`${s.innerSection} ${
              darkenBackground && s.blackBackground
            }`}
          >
            {content}
          </div>
          <div className={s.footerSection}>
            <p style={{ ...footerStyle }}>
              By signing up and entering this competition, you agree to our{' '}
              <Link href="/terms-and-conditions">
                <a
                  style={{
                    textDecoration: 'underline',
                    fontWeight: '600',
                    color: 'white',
                    ...footerStyle,
                  }}
                >
                  Terms & Conditions
                </a>
              </Link>
              .<br />
              You also agree for DAYMADE to occasionally email you about special
              offers.
            </p>
            <p style={{ ...footerStyle }}>
              DAYMADE is an associated brand of, and operated by, DAYMADE LTD
              (registered in England & Wales, company number 12333770).
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`${s.mobileContainer} ${
        darkenBackground && s.blackBackground
      }`}
    >
      <div className={s.imageContainer}>
        <img className={s.backgroundImage} src={backgroundImageUrl} />
        <div className={s.innerSection}>{content}</div>
      </div>
    </div>
  );
};

export default PlayFreeImageCarousel;
